$(document).on('turbolinks:load', function() {
  // プレビューボタンの data-disabled が独立して外せないので力技
  $('.card-footer .btn.preview').click(function () {
    setTimeout(function () {
      $('.card-footer .btn').prop('disabled', false);
    }, 1000);
  });

  $(".accordion-switch").each(function( index ) {
    var self = $( this );
    if (self.parent().find(".triangle-container").length === 0) {
      $( "<div class='triangle-container'><div class='rouned-triangle'/></div>" ).insertBefore(self);
    }
    
  });
  $("nav.pagination").each(function( index ) {
    var self = $( this );
    if (!self.parent().hasClass("pagy-nav-container")) {
      self.wrap($( "<div class='pagy-nav-container'/>" ));
    }
  });
  $('.accordion-switch').on('change', function(evt) {
    var self = $(this);
    var arrow = self.parent();
    arrow.toggleClass("opened", 1000);
    var roomInfo = self.closest(".row-table").find(".row-information");
    roomInfo.toggleClass("hidden", 1000);
    var media = roomInfo.find(".media-photo");
    var img = roomInfo.find(".slick-current").find("img");
    media.height(img.height());
  });

  if ($('.card-footer .btn-left').children().length <= 0) {
    $('.card-footer .btn-left').remove();
  } 

  if ($('.card-footer .btn-right').children().length <= 0) {
    $('.card-footer .btn-right').remove();
  } 

  var sidenav_change = function () {
    var sidenav_container_width = $(".navigate_menu_with_accordion").width();
    var sidenav = $(".navigate_menu_with_accordion .accordion_content .sidenav-list>li");
    sidenav.removeClass("last-row").removeClass("only-cell");
    if (sidenav_container_width <= 670) {
      if (sidenav.length % 2 === 1 ) {
        $(sidenav[sidenav.length - 1]).addClass("last-row only-cell");
      }
    } else if (sidenav_container_width <= 1099){
      if (sidenav.length % 3 === 2 ) {
        $(sidenav[sidenav.length - 1]).addClass("last-row");
        $(sidenav[sidenav.length - 2]).addClass("last-row");
      } else if (sidenav.length % 3 === 1) {
        $(sidenav[sidenav.length - 1]).addClass("last-row only-cell");
      }
    }
  }
  sidenav_change();
  $(window).on('resize', function(evt) {
    sidenav_change();
  });

  // 施設の追加/編集(facilities/_form.html.slim)画面または
  // 所管の追加/編集(groups/_form.html.slim)画面から呼び出される。
  var use_report_model = null;    // 処理するRailsモデル: 施設'facility'か所管('group')か
  var use_report_form_sel = null; // form要素のcssクラス

    // 施設(facilities/_form.html.slim)または所管(groups/_form.slim.html)で定義
    //   [JavaScriptグローバル変数]
    //   - g_rooms_use_report_templates: 自身に所属する部屋(/施設)のuse_template_id配列
    //     (facilities/_form.html.slimまたはにて設定)
    //   [html form]
    //   - cssクラスedit-facility-form / edit-group-formのform: form要素
    //   - cssクラスuse-report-templateのdiv: 利用報告書テンプレート 表示/非表示切替範囲
    //   - cssクラスfacility-save / group-saveのボタン: 「保存する」ボタン
    //   - select要素 facility[use_report] / group[use_report]: 利用報告機能 無効(disabled)/有効(enabled)
    //   - select要素 facility[use_report_template_id] / group[use_report_template_id]: 利用報告書テンプレート選択肢
    //     整数のテンプレートID値または未選択('select')
    //   - ダイアログ dialog.update-room-use-report: 所属する部屋(/施設)設定を上書き選択ダイアログ
    //   - input要素 room_use_report: 所属する部屋(/施設)設定を上書きを表すtrue / falseパラメタ
    if ($('.edit-facility-form').length > 0) {
    use_report_model = 'facility';
    use_report_form_sel = '.edit-facility-form';
  } else if ($('.edit-group-form').length > 0) {
    use_report_model = 'group';
    use_report_form_sel = '.edit-group-form';
  }

  if (use_report_form_sel != null) {
    var use_report_form_el = $(use_report_form_sel);
    var use_report_el = $(`${use_report_form_sel} select[name='${use_report_model}[use_report]']`);
    var use_report_template_id_el = $(`${use_report_form_sel} select[name='${use_report_model}[use_report_template_id]']`);

    // 自身に所属する部屋(/施設)に利用報告設定がある時は、利用報告機能 有効 で初期化する。
    if (use_report_el.val() == 'disabled' && g_rooms_use_report_templates.length > 0) {
      use_report_el.val('enabled');
      use_report_template_id_el.val('select');
    }

    // 「利用報告機能」選択に応じ「利用報告書」表示切替
    use_report_el.on('change', function() {
      if ($(this).val() == 'enabled') {
        // 表示
        $(`${use_report_form_sel} .use-report-template`).slideDown();
      } else {
        // 非表示
        $(`${use_report_form_sel} .use-report-template`).slideUp();
      }
    });
    use_report_el.trigger('change');

    var do_submit = function() {
      if (use_report_model == 'facility') {
        var map_el = $(`${use_report_form_sel} input[name='facility[map]']`);
        var m = map_el.val();
        map_el.val(btoa(unescape(encodeURIComponent(m))));
        use_report_form_el.trigger('submit');
        map_el.val(m);
      } else {
        use_report_form_el.trigger('submit');
      }
    };

    // 「保存する」クリック時に開くダイアログ (views/shared/_update_room_use_report_dialog.html.slim)
    //   (views/facilities/_form.html.slimまたはviews/facilities/_form.html.slimでrenderされる)
    //   配下の部屋(/施設)に利用報告書設定がある時に上書するかの制御
    var room_use_report_dialog = function() {
      var dialog_sel = `${use_report_form_sel} dialog.update-room-use-report`;

      // 上書を示すパラメタ(Railsコントローラupdateアクションに渡す)
      var update_room_use_report = function(value) {
        $(`${use_report_form_sel} input[name="room_use_report"]`).val(value);
      };

      var button_yes = $(`${dialog_sel} button[name="yes"]`);
      var button_no = $(`${dialog_sel} button[name="no"]`);
      button_yes.on('click', function() {
        update_room_use_report(true);
        do_submit();
      });

      button_no.on('click', function() {
        do_submit();
      });

      $(dialog_sel).on('keydown', function(events) {
        switch (events.key) {
          case 'Tab':
            // タブ キーによるボタン間フォーカス移動
            if (button_yes.is(':focus')) {
              button_no.trigger('focus');
            } else {
              button_yes.trigger('focus');
            }
            return false;
            break;
          case 'Enter':
            // ENTERキーでsbumit
            if (button_yes.is(':focus')) {
              update_room_use_report(true);
            }
            do_submit();
        }
      });

      // $('dialog.use-report-confirm button[name="yes"]').trigger('focus');
      $(dialog_sel)[0].showModal();
    };

    // 「所管の編集」画面の「保存する」(.group-save)、「施設の編集」画面の「保存する」(.facility-save)クリック時処理
    $(`${use_report_form_sel} .${use_report_model}-save`).on('click', function() {
      // 「利用報告書機能」が「利用する」なのに「利用報告書」が未選択
      if (use_report_el.val() == 'enabled' && use_report_template_id_el.val() == 'select') {
        alert('利用報告書を選択してください');
        return false;
      }

      // before_facility_use_report, before_facility_use_report_template_id
      if (g_rooms_use_report_templates.length > 0) {
        room_use_report_dialog();
        return false;
      }

      do_submit();
    });
  }
});
